import { trackEvent } from './analytics';

const MAX_MESSAGE_LENGTH = 250;

const truncate = (value) => {
  const text = String(value || '');
  if (text.length <= MAX_MESSAGE_LENGTH) return text;
  return `${text.slice(0, MAX_MESSAGE_LENGTH)}...`;
};

export const reportClientError = (error, context = {}) => {
  const message = truncate(error?.message || error || 'Unknown client error');
  const stack = truncate(error?.stack || '');
  const safeContext = {
    route: window?.location?.pathname || '',
    ...context,
  };

  console.error('[ClientError]', message, safeContext);

  trackEvent('client_error', {
    message,
    stack,
    route: truncate(safeContext.route || ''),
    source: truncate(safeContext.source || ''),
  });
};

export const registerGlobalClientErrorHandlers = () => {
  if (window.__xiluvaClientErrorHandlersRegistered) return;
  window.__xiluvaClientErrorHandlersRegistered = true;

  window.addEventListener('error', (event) => {
    reportClientError(event.error || event.message, {
      source: 'window.error',
      filename: event.filename || '',
      lineno: event.lineno || 0,
      colno: event.colno || 0,
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    reportClientError(reason instanceof Error ? reason : new Error(String(reason)), {
      source: 'window.unhandledrejection',
    });
  });
};

